import { Component, inject } from '@angular/core';
import { IpoLanguageService } from '@ip-only/front-end-library';
import { ImageCompressService } from '../../../image-compress/image-compress.service';
import { ImagePreviewV2InitService } from '../../../image-preview-v2/service/init/image-preview-v2-init.service';
import { FileInputData } from '../../report-inputs/report-input-entities';
import { RolloutProgressReportAnswersService } from '../../service/answers/rollout-progress-report-answers.service';
import { RolloutProgressReportEntities } from '../../service/entities';
import { RolloutProgressReportFilesService } from '../../service/files/rollout-progress-report-files.service';
import { RolloutProgressReportHelperService } from '../../service/helper/rollout-progress-report-helper.service';
import { RolloutProgressReportsService } from '../../service/reports/rollout-progress-reports.service';

@Component({
  selector: 'app-report-group-base',
  imports: [],
  template: '',
})
export class ReportGroupBaseComponent {
  readonly helperService = inject(RolloutProgressReportHelperService);
  readonly reportService = inject(RolloutProgressReportsService);
  readonly languageService = inject(IpoLanguageService);
  private readonly answerService = inject(RolloutProgressReportAnswersService);
  private readonly fileService = inject(RolloutProgressReportFilesService);
  private readonly imageCompressService = inject(ImageCompressService);
  private readonly imagePreviewV2InitService = inject(
    ImagePreviewV2InitService,
  );

  saveAnswer = (
    answerRequest: RolloutProgressReportEntities.v3.AnswerRequestType,
    definitionId: string,
    reportId: string,
    reportGroup: RolloutProgressReportEntities.v3.Groups,
  ): void => {
    this.answerService
      .createAnswer$(reportId, definitionId, answerRequest, reportGroup)
      .mutate();
  };

  saveFile = (
    $event: Event,
    definition: RolloutProgressReportEntities.v3.Definition,
    reportId: string,
    reportGroup: RolloutProgressReportEntities.v3.Groups,
    isFileAndText: boolean,
  ): void => {
    this.imageCompressService.compressFilesAndMutate(
      $event,
      isFileAndText
        ? (definition.fileAndText?.file.isImages as boolean)
        : (definition.file?.isImages as boolean),
      (fileFormData: FormData) =>
        this.answerService.createFile$(
          reportId,
          definition.id,
          fileFormData,
          reportGroup,
          isFileAndText,
          false,
        ),
    );
  };

  deleteFile = (
    definitionId: string,
    fileId: string,
    reportId: string,
    reportGroup: RolloutProgressReportEntities.v3.Groups,
  ): void => {
    this.answerService
      .deleteFile$(reportId, definitionId, fileId, reportGroup)
      .mutate();
  };

  undoSelfInpseciton = (
    definitionId: string,
    reportId: string,
    reportGroup: RolloutProgressReportEntities.v3.Groups,
  ): void => {
    this.answerService
      .deleteAnswer$(reportId, definitionId, reportGroup)
      .mutate();
  };

  openImagePreview(
    answer: FileInputData,
    reportId: string,
    reportGroup: RolloutProgressReportEntities.v3.Groups,
    isFileAndText: boolean,
  ) {
    if (answer.fileData.files) {
      this.imagePreviewV2InitService.setImagePreviewAttachments(
        (id: string) => this.fileService.getFile$(id),
        answer.fileData.files,
      );
      this.imagePreviewV2InitService.setImagePreviewData({
        reportId: reportId,
        definitionId: answer.id,
        group: reportGroup,
        isFileAndText,
      });
      this.imagePreviewV2InitService.setShowImagePreview(true);
    }
  }

  downloadFiles = (files: { fileName: string; fileId: string }[]) => {
    this.fileService.downloadFiles(files);
  };
}
